import type {FieldReturn} from '../types'

export const fieldset = (name: string, fields: FieldReturn[]): FieldReturn[] =>
  fields.map((field: FieldReturn) => ({...field, fieldset: name}))
